/* bb waitlist modal — opens on click, fills in product title, focuses first input.
   Submission is a normal Shopify {% form 'contact' %} POST → mail to shop owner. */

(function () {
  var modal = document.getElementById('bb-waitlist-modal');
  if (!modal) return;

  if (modal.parentNode !== document.body) document.body.appendChild(modal);

  var subjectInput = modal.querySelector('[data-bb-waitlist-subject]');
  var productInput = modal.querySelector('[data-bb-waitlist-product]');
  var leadEl = modal.querySelector('[data-bb-product-name]');
  var lastTrigger = null;

  function open(trigger) {
    lastTrigger = trigger || null;
    var title = trigger && trigger.getAttribute('data-bb-product-title');
    if (title) {
      if (subjectInput) subjectInput.value = 'Wartelisten-Anmeldung: ' + title;
      if (productInput) productInput.value = title;
      if (leadEl) leadEl.textContent = 'Setz dich auf die Warteliste für „' + title + '". Wir melden uns, sobald Plätze frei werden.';
    }
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bb-modal-open');
    var firstInput = modal.querySelector('input[type="text"], input[type="email"]');
    if (firstInput) firstInput.focus();
  }

  function close() {
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bb-modal-open');
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-bb-open="waitlist"]');
    if (opener) {
      e.preventDefault();
      open(opener);
      return;
    }
    if (e.target === modal && modal.getAttribute('aria-hidden') === 'false') {
      var closeBtn = modal.querySelector('[data-bb-close]');
      if (e.target.closest('[data-bb-close]') || e.target === modal) close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') close();
  });

  // If the form was just submitted successfully, keep the modal open so the
  // success message is visible.
  var posted = modal.querySelector('.bb-form__status--success');
  if (posted) {
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bb-modal-open');
  }
})();
